import { ProductTab } from './products.model'

export const productTabs: ProductTab[] = [
  {
    name: 'Crédito com\nGarantia de Imóvel',
    image: 'credito-imovel.png',
    alt: 'Ilustração de uma casa em uma balança ao lado de moedas',
    features: [
      'R$50 mil a R$ 25 milhões (uso livre)',
      'Até 60% do valor do imóvel',
      'Pessoa Física ou Pessoa Jurídica',
      'Prazo de até 240 meses'
    ],
    link: '/emprestimo-com-garantia-de-imovel',
    cta: 'Conheça o Home Equity',
    ariaLabel: 'Saiba mais sobre Crédito com Garantia de Imóvel',
    dataLayer: {
      category: 'Clique',
      action: 'Portfólio',
      label: 'Crédito com Garantia de Imóvel - Botão Saiba mais'
    }
  },
  {
    name: 'Crédito para\nConstrução',
    image: 'construcao.png',
    alt: 'Ilustração de um capacete de construção',
    features: [
      'Valor mínimo do imóvel R$500 mil',
      'Até 50% do valor do projeto financiado',
      'Terreno quitado ou com saldo devedor',
      'Dentro e fora de condomínio'
    ],
    link: '/financiamento-para-construcao',
    cta: 'Veja o Crédito para Construção',
    ariaLabel: 'Saiba mais sobre Crédito para Construção',
    dataLayer: {
      category: 'Clique',
      action: 'Portfólio',
      label: 'Crédito para Construção - Botão Saiba mais'
    }
  },
  {
    name: 'Financiamento\nimobiliário (SFI)',
    image: 'imobiliario.png',
    alt: 'Ilustração de uma maleta com moedas',
    features: [
      'Até 60% do valor do imóvel',
      'Para Pessoa Física ou Pessoa Jurídica',
      'Sem limite de valor do imóvel',
      'Prazo de 240 meses'
    ],
    link: '/financiamento-imobiliario',
    cta: 'Descubra o SFI',
    ariaLabel: 'Saiba mais sobre Financiamento imobiliário (SFI)',
    dataLayer: {
      category: 'Clique',
      action: 'Portfólio',
      label: 'Financiamento imobiliário (SFI) - Botão Saiba mais'
    }
  },
  {
    name: 'Crédito para\nCondomínio',
    image: 'condominio.png',
    alt: 'Ilustração de um prédio com árvores',
    features: [
      'Sem fiador ou garantias pessoais',
      'Uso para modernizar, reformar e realizar melhorias',
      'Prazo de até 90 meses',
      'Fluxo de pagamento personalizado'
    ],
    link: '/condo',
    cta: 'Veja o Crédito para Condomínios',
    ariaLabel: 'Saiba mais sobre Crédito para Condomínio',
    dataLayer: {
      category: 'Clique',
      action: 'Portfólio',
      label: 'Crédito para Condomínio - Botão Saiba mais'
    }
  }
]
